import {
  System_instance3bcuv0kn0rmcj as System_instance,
  InstantIso8601Serializer_getInstancerozk8wbw256e as InstantIso8601Serializer_getInstance,
} from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_HOURS_getInstance2a8ae0fbaua67 as DurationUnit_HOURS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  isInterface3d6p8outrmvmk as isInterface,
  getValue48kllevslyh6 as getValue,
  equals2au1ep9vhcato as equals,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  BooleanSerializer_getInstancet3wtk7fl7i4f as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleValueEndpointCacheStrategy2snxed6lorji8 as SimpleValueEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  ILocalSource1zuymxsgjvvss as ILocalSource,
  SimpleCacheLocalSource3mbicvk11uh40 as SimpleCacheLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
} from './Shared7Punches-common-base.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance_0,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  ApiVersion_MAY_2026_getInstance1jn2lakqb99ub as ApiVersion_MAY_2026_getInstance,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_1 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Companion_getInstance1rlvzabi952im as Companion_getInstance_2,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiEarnedWageAccessSettingsData, 'ApiEarnedWageAccessSettingsData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiEarnedWageAccessUserData, 'ApiEarnedWageAccessUserData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForCompanion(Companion_1);
initMetadataForClass(EarnedWageAccessUserEntity, 'EarnedWageAccessUserEntity');
initMetadataForFunctionReference(ILocalSource$put$ref, VOID, VOID, [1]);
initMetadataForLambda(PayRepository$earnedWageAccessSettingsCacheStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForFunctionReference(ILocalSource$put$ref_1, VOID, VOID, [1]);
initMetadataForLambda(PayRepository$earnedWageAccessUserCacheStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForInterface(PayAccessor, 'PayAccessor', VOID, VOID, VOID, [0]);
initMetadataForClass(PayRepository, 'PayRepository', VOID, VOID, [PayAccessor], [0]);
initMetadataForInterface(IPayRemoteSource, 'IPayRemoteSource', VOID, VOID, VOID, [1, 2]);
initMetadataForCoroutine($fetchEarnedWageAccessSettingsCOROUTINE$5, CoroutineImpl);
initMetadataForCoroutine($fetchEarnedWageAccessUserCOROUTINE$7, CoroutineImpl);
initMetadataForClass(PayRemoteSource, 'PayRemoteSource', VOID, VOID, [IPayRemoteSource], [1, 2]);
initMetadataForClass(EarnedWageAccessSettings, 'EarnedWageAccessSettings');
initMetadataForInterface(IClairSdkAppKeyProvider, 'IClairSdkAppKeyProvider');
initMetadataForClass(ClairSdkAppKeyProvider, 'ClairSdkAppKeyProvider', ClairSdkAppKeyProvider, VOID, [IClairSdkAppKeyProvider]);
//endregion
function toDomain(_this__u8e3s4) {
  return new EarnedWageAccessSettings(_this__u8e3s4.n8t_1);
}
function toEntity(_this__u8e3s4) {
  return new EarnedWageAccessUserEntity(_this__u8e3s4.o8t_1, _this__u8e3s4.p8t_1, System_instance.w2b());
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.pay.data.models.ApiEarnedWageAccessSettingsData', this, 1);
  tmp0_serialDesc.wy('earned_wage_access_enabled', false);
  this.q8t_1 = tmp0_serialDesc;
}
protoOf($serializer).r8t = function (encoder, value) {
  var tmp0_desc = this.q8t_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.rs(tmp0_desc, 0, value.n8t_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.r8t(encoder, value instanceof ApiEarnedWageAccessSettingsData ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.q8t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.mr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.mr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiEarnedWageAccessSettingsData_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.q8t_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiEarnedWageAccessSettingsData_init_$Init$(seen0, isEarnedWageAccessEnabled, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().q8t_1);
  }
  $this.n8t_1 = isEarnedWageAccessEnabled;
  return $this;
}
function ApiEarnedWageAccessSettingsData_init_$Create$(seen0, isEarnedWageAccessEnabled, serializationConstructorMarker) {
  return ApiEarnedWageAccessSettingsData_init_$Init$(seen0, isEarnedWageAccessEnabled, serializationConstructorMarker, objectCreate(protoOf(ApiEarnedWageAccessSettingsData)));
}
function ApiEarnedWageAccessSettingsData(isEarnedWageAccessEnabled) {
  this.n8t_1 = isEarnedWageAccessEnabled;
}
protoOf(ApiEarnedWageAccessSettingsData).toString = function () {
  return 'ApiEarnedWageAccessSettingsData(isEarnedWageAccessEnabled=' + this.n8t_1 + ')';
};
protoOf(ApiEarnedWageAccessSettingsData).hashCode = function () {
  return getBooleanHashCode(this.n8t_1);
};
protoOf(ApiEarnedWageAccessSettingsData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiEarnedWageAccessSettingsData))
    return false;
  var tmp0_other_with_cast = other instanceof ApiEarnedWageAccessSettingsData ? other : THROW_CCE();
  if (!(this.n8t_1 === tmp0_other_with_cast.n8t_1))
    return false;
  return true;
};
function Companion_0() {
}
var Companion_instance_2;
function Companion_getInstance_4() {
  return Companion_instance_2;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.pay.data.models.ApiEarnedWageAccessUserData', this, 2);
  tmp0_serialDesc.wy('employee_key', false);
  tmp0_serialDesc.wy('expires_at', false);
  this.s8t_1 = tmp0_serialDesc;
}
protoOf($serializer_0).t8t = function (encoder, value) {
  var tmp0_desc = this.s8t_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.o8t_1);
  tmp1_output.bt(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), value.p8t_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.t8t(encoder, value instanceof ApiEarnedWageAccessUserData ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.s8t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.wr(tmp0_desc, 1, InstantIso8601Serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return ApiEarnedWageAccessUserData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_0).xn = function () {
  return this.s8t_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), InstantIso8601Serializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ApiEarnedWageAccessUserData_init_$Init$(seen0, employeeKey, expiresAt, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_0().s8t_1);
  }
  $this.o8t_1 = employeeKey;
  $this.p8t_1 = expiresAt;
  return $this;
}
function ApiEarnedWageAccessUserData_init_$Create$(seen0, employeeKey, expiresAt, serializationConstructorMarker) {
  return ApiEarnedWageAccessUserData_init_$Init$(seen0, employeeKey, expiresAt, serializationConstructorMarker, objectCreate(protoOf(ApiEarnedWageAccessUserData)));
}
function ApiEarnedWageAccessUserData(employeeKey, expiresAt) {
  this.o8t_1 = employeeKey;
  this.p8t_1 = expiresAt;
}
protoOf(ApiEarnedWageAccessUserData).toString = function () {
  return 'ApiEarnedWageAccessUserData(employeeKey=' + this.o8t_1 + ', expiresAt=' + this.p8t_1.toString() + ')';
};
protoOf(ApiEarnedWageAccessUserData).hashCode = function () {
  var result = getStringHashCode(this.o8t_1);
  result = imul(result, 31) + this.p8t_1.hashCode() | 0;
  return result;
};
protoOf(ApiEarnedWageAccessUserData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiEarnedWageAccessUserData))
    return false;
  var tmp0_other_with_cast = other instanceof ApiEarnedWageAccessUserData ? other : THROW_CCE();
  if (!(this.o8t_1 === tmp0_other_with_cast.o8t_1))
    return false;
  if (!this.p8t_1.equals(tmp0_other_with_cast.p8t_1))
    return false;
  return true;
};
function Companion_1() {
  Companion_instance_3 = this;
  var tmp = this;
  // Inline function 'kotlin.time.Companion.hours' call
  Companion_getInstance();
  tmp.u8t_1 = toDuration(1, DurationUnit_HOURS_getInstance());
}
var Companion_instance_3;
function Companion_getInstance_5() {
  if (Companion_instance_3 == null)
    new Companion_1();
  return Companion_instance_3;
}
function EarnedWageAccessUserEntity(employeeKey, expiresAt, fetchedAt) {
  Companion_getInstance_5();
  this.v8t_1 = employeeKey;
  this.w8t_1 = expiresAt;
  this.x8t_1 = fetchedAt;
}
protoOf(EarnedWageAccessUserEntity).toString = function () {
  return 'EarnedWageAccessUserEntity(employeeKey=' + this.v8t_1 + ', expiresAt=' + this.w8t_1.toString() + ', fetchedAt=' + this.x8t_1.toString() + ')';
};
protoOf(EarnedWageAccessUserEntity).hashCode = function () {
  var result = getStringHashCode(this.v8t_1);
  result = imul(result, 31) + this.w8t_1.hashCode() | 0;
  result = imul(result, 31) + this.x8t_1.hashCode() | 0;
  return result;
};
protoOf(EarnedWageAccessUserEntity).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EarnedWageAccessUserEntity))
    return false;
  var tmp0_other_with_cast = other instanceof EarnedWageAccessUserEntity ? other : THROW_CCE();
  if (!(this.v8t_1 === tmp0_other_with_cast.v8t_1))
    return false;
  if (!this.w8t_1.equals(tmp0_other_with_cast.w8t_1))
    return false;
  if (!this.x8t_1.equals(tmp0_other_with_cast.x8t_1))
    return false;
  return true;
};
function ILocalSource$put$ref($boundThis) {
  this.y8t_1 = $boundThis;
}
protoOf(ILocalSource$put$ref).z8t = function (p0, $completion) {
  return this.y8t_1.m2u(p0, $completion);
};
protoOf(ILocalSource$put$ref).h9 = function (p1, $completion) {
  return this.z8t(p1 instanceof EarnedWageAccessSettings ? p1 : THROW_CCE(), $completion);
};
function ILocalSource$put$ref_0($boundThis) {
  var i = new ILocalSource$put$ref($boundThis);
  var l = function (p0, $completion) {
    return i.z8t(p0, $completion);
  };
  l.callableName = 'put';
  l.$arity = 1;
  return l;
}
function PayRepository$earnedWageAccessSettingsCacheStrategy$slambda(this$0, resultContinuation) {
  this.i8u_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(PayRepository$earnedWageAccessSettingsCacheStrategy$slambda).l8u = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(PayRepository$earnedWageAccessSettingsCacheStrategy$slambda).ma = function ($completion) {
  return this.l8u($completion);
};
protoOf(PayRepository$earnedWageAccessSettingsCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.j8u_1 = this.i8u_1.o8u_1;
          this.n8_1 = 1;
          suspendResult = this.i8u_1.p8u_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.k8u_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.j8u_1.s8u(this.k8u_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 3;
          continue $sm;
        case 2:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 3;
          continue $sm;
        case 3:
          return suspendResult;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(PayRepository$earnedWageAccessSettingsCacheStrategy$slambda).m32 = function (completion) {
  return new PayRepository$earnedWageAccessSettingsCacheStrategy$slambda(this.i8u_1, completion);
};
function PayRepository$earnedWageAccessSettingsCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new PayRepository$earnedWageAccessSettingsCacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.l8u($completion);
  };
  l.$arity = 0;
  return l;
}
function PayRepository$earnedWageAccessSettingsCacheStrategy$lambda(it) {
  return toDomain(it);
}
function ILocalSource$put$ref_1($boundThis) {
  this.t8u_1 = $boundThis;
}
protoOf(ILocalSource$put$ref_1).u8u = function (p0, $completion) {
  return this.t8u_1.m2u(p0, $completion);
};
protoOf(ILocalSource$put$ref_1).h9 = function (p1, $completion) {
  return this.u8u(p1 instanceof EarnedWageAccessUserEntity ? p1 : THROW_CCE(), $completion);
};
function ILocalSource$put$ref_2($boundThis) {
  var i = new ILocalSource$put$ref_1($boundThis);
  var l = function (p0, $completion) {
    return i.u8u(p0, $completion);
  };
  l.callableName = 'put';
  l.$arity = 1;
  return l;
}
function PayRepository$earnedWageAccessUserCacheStrategy$slambda(this$0, resultContinuation) {
  this.d8v_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(PayRepository$earnedWageAccessUserCacheStrategy$slambda).h8v = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(PayRepository$earnedWageAccessUserCacheStrategy$slambda).ma = function ($completion) {
  return this.h8v($completion);
};
protoOf(PayRepository$earnedWageAccessUserCacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.e8v_1 = this.d8v_1.o8u_1;
          this.n8_1 = 1;
          suspendResult = this.d8v_1.p8u_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.f8v_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.d8v_1.p8u_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.g8v_1 = suspendResult;
          this.n8_1 = 3;
          suspendResult = this.e8v_1.i8v(this.f8v_1, this.g8v_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 4;
          continue $sm;
        case 3:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 4;
          continue $sm;
        case 4:
          return suspendResult;
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 5) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(PayRepository$earnedWageAccessUserCacheStrategy$slambda).m32 = function (completion) {
  return new PayRepository$earnedWageAccessUserCacheStrategy$slambda(this.d8v_1, completion);
};
function PayRepository$earnedWageAccessUserCacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new PayRepository$earnedWageAccessUserCacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.h8v($completion);
  };
  l.$arity = 0;
  return l;
}
function PayRepository$earnedWageAccessUserCacheStrategy$lambda(it) {
  return toEntity(it);
}
function PayRepository(localSource, earnedWageAccessUserLocalSource, remoteSource, sessionDataProvider) {
  this.m8u_1 = localSource;
  this.n8u_1 = earnedWageAccessUserLocalSource;
  this.o8u_1 = remoteSource;
  this.p8u_1 = sessionDataProvider;
  var tmp = this;
  var tmp_0 = this.m8u_1.n18();
  var tmp_1 = ILocalSource$put$ref_0(this.m8u_1);
  var tmp_2 = PayRepository$earnedWageAccessSettingsCacheStrategy$slambda_0(this, null);
  tmp.q8u_1 = new SimpleValueEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, PayRepository$earnedWageAccessSettingsCacheStrategy$lambda);
  var tmp_3 = this;
  var tmp_4 = this.n8u_1.n18();
  var tmp_5 = ILocalSource$put$ref_2(this.n8u_1);
  var tmp_6 = PayRepository$earnedWageAccessUserCacheStrategy$slambda_0(this, null);
  tmp_3.r8u_1 = new SimpleValueEndpointCacheStrategy(tmp_4, tmp_5, tmp_6, PayRepository$earnedWageAccessUserCacheStrategy$lambda);
}
function IPayRemoteSource() {
}
function PayRemoteSource$fetchEarnedWageAccessSettings$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function PayRemoteSource$fetchEarnedWageAccessSettings$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance_0().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function PayRemoteSource$fetchEarnedWageAccessUser$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function PayRemoteSource$fetchEarnedWageAccessUser$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance_0().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $fetchEarnedWageAccessSettingsCOROUTINE$5(_this__u8e3s4, companyId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r8v_1 = _this__u8e3s4;
  this.s8v_1 = companyId;
}
protoOf($fetchEarnedWageAccessSettingsCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.t8v_1 = this.r8v_1.l8x_1;
          var tmp_1 = this;
          tmp_1.u8v_1 = 'pay/company/' + this.s8v_1.toString() + '/earned_wage_access_settings';
          var tmp_2 = this;
          tmp_2.v8v_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.w8v_1 = this.t8v_1;
          this.x8v_1 = this.u8v_1;
          this.y8v_1 = this.v8v_1;
          var tmp_3 = this;
          tmp_3.z8v_1 = PayRemoteSource$fetchEarnedWageAccessSettings$lambda;
          this.o8_1 = 2;
          var tmp_4 = this;
          tmp_4.b8w_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.c8w_1 = this.w8v_1.f6l_1;
          var tmp_6 = this;
          tmp_6.d8w_1 = buildV2Path(this.w8v_1, this.x8v_1);
          this.e8w_1 = this.c8w_1;
          this.f8w_1 = this.d8w_1;
          var tmp_7 = this;
          tmp_7.g8w_1 = this.e8w_1;
          this.h8w_1 = this.g8w_1;
          var tmp_8 = this;
          tmp_8.i8w_1 = this.h8w_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.f8w_1);
          headers(this_0, PayRemoteSource$fetchEarnedWageAccessSettings$lambda_0(this.y8v_1));
          this_0.z5n(this.z8v_1);
          tmp_9.j8w_1 = this_0;
          this.k8w_1 = this.i8w_1;
          this.l8w_1 = this.j8w_1;
          this.l8w_1.q4r_1 = Companion_getInstance_1().f41_1;
          var tmp_10 = this;
          tmp_10.m8w_1 = this.k8w_1;
          var tmp_11 = this;
          tmp_11.n8w_1 = this.l8w_1;
          this.o8w_1 = this.m8w_1;
          this.p8w_1 = this.n8w_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.p8w_1, this.o8w_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.q8w_1 = suspendResult;
          var tmp_12 = this;
          this.b8w_1;
          var value = this.q8w_1;
          tmp_12.a8w_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.r8w_1 = this.q8_1;
            var tmp_14 = this;
            throw this.r8w_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.s8w_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.s8w_1;
              tmp_16.a8w_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.t8w_1 = this.a8w_1;
          this.u8w_1 = this.t8w_1;
          this.v8w_1 = Result__exceptionOrNull_impl_p6xea9(this.u8w_1);
          if (this.v8w_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.u8w_1);
            tmp_17.x8w_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.y8w_1 = this.x8w_1;
            var tmp_19 = this;
            tmp_19.z8w_1 = this.y8w_1;
            this.a8x_1 = this.z8w_1;
            this.b8x_1 = this.a8x_1.c4u().z43_1;
            var containsArg = this.b8x_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_20 = this;
              tmp_20.e8x_1 = Companion_instance;
              if (getKClass(ApiEarnedWageAccessSettingsData).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.g8x_1 = this.a8x_1;
                this.h8x_1 = this.g8x_1;
                this.n8_1 = 6;
                var tmp_22 = this.h8x_1.y4u();
                var tmp_23 = getKClass(ApiEarnedWageAccessSettingsData);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiEarnedWageAccessSettingsData), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.i8x_1 = this.a8x_1;
                this.j8x_1 = this.i8x_1;
                this.n8_1 = 5;
                var tmp_27 = this.j8x_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.k8x_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.a8x_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.v8w_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.w8w_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.k8x_1;
          tmp_33.c8x_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiEarnedWageAccessSettingsData), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.f8x_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_37 = this;
          tmp_37.f8x_1 = suspendResult instanceof ApiEarnedWageAccessSettingsData ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.f8x_1;
          var tmp_38 = this;
          this.e8x_1;
          tmp_38.d8x_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.d8x_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_43 = this;
          var this_2 = this.d8x_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.c8x_1 = tmp_44.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.w8w_1 = new Result(this.c8x_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.w8w_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $fetchEarnedWageAccessUserCOROUTINE$7(_this__u8e3s4, companyId, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.u8x_1 = _this__u8e3s4;
  this.v8x_1 = companyId;
  this.w8x_1 = userId;
}
protoOf($fetchEarnedWageAccessUserCOROUTINE$7).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 12;
          var tmp_0 = this;
          tmp_0.x8x_1 = this.u8x_1.l8x_1;
          var tmp_1 = this;
          tmp_1.y8x_1 = 'labor/company/' + this.v8x_1.toString() + '/clair_employee/' + this.w8x_1.toString();
          var tmp_2 = this;
          tmp_2.z8x_1 = ApiVersion_MAY_2026_getInstance();
          this.a8y_1 = this.x8x_1;
          this.b8y_1 = this.y8x_1;
          this.c8y_1 = this.z8x_1;
          var tmp_3 = this;
          tmp_3.d8y_1 = PayRemoteSource$fetchEarnedWageAccessUser$lambda;
          this.o8_1 = 2;
          var tmp_4 = this;
          tmp_4.f8y_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.g8y_1 = this.a8y_1.f6l_1;
          var tmp_6 = this;
          tmp_6.h8y_1 = buildV2Path(this.a8y_1, this.b8y_1);
          this.i8y_1 = this.g8y_1;
          this.j8y_1 = this.h8y_1;
          var tmp_7 = this;
          tmp_7.k8y_1 = this.i8y_1;
          this.l8y_1 = this.k8y_1;
          var tmp_8 = this;
          tmp_8.m8y_1 = this.l8y_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.j8y_1);
          headers(this_0, PayRemoteSource$fetchEarnedWageAccessUser$lambda_0(this.c8y_1));
          this_0.z5n(this.d8y_1);
          tmp_9.n8y_1 = this_0;
          this.o8y_1 = this.m8y_1;
          this.p8y_1 = this.n8y_1;
          this.p8y_1.q4r_1 = Companion_getInstance_1().f41_1;
          var tmp_10 = this;
          tmp_10.q8y_1 = this.o8y_1;
          var tmp_11 = this;
          tmp_11.r8y_1 = this.p8y_1;
          this.s8y_1 = this.q8y_1;
          this.t8y_1 = this.r8y_1;
          this.n8_1 = 1;
          suspendResult = (new HttpStatement(this.t8y_1, this.s8y_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.u8y_1 = suspendResult;
          var tmp_12 = this;
          this.f8y_1;
          var value = this.u8y_1;
          tmp_12.e8y_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 12;
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.o8_1 = 12;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.v8y_1 = this.q8_1;
            var tmp_14 = this;
            throw this.v8y_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.w8y_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.w8y_1;
              tmp_16.e8y_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 3;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          this.o8_1 = 12;
          this.x8y_1 = this.e8y_1;
          this.y8y_1 = this.x8y_1;
          this.z8y_1 = Result__exceptionOrNull_impl_p6xea9(this.y8y_1);
          if (this.z8y_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.y8y_1);
            tmp_17.b8z_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.c8z_1 = this.b8z_1;
            var tmp_19 = this;
            tmp_19.d8z_1 = this.c8z_1;
            this.e8z_1 = this.d8z_1;
            this.f8z_1 = this.e8z_1.c4u().z43_1;
            var containsArg = this.f8z_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 8;
              var tmp_20 = this;
              tmp_20.i8z_1 = Companion_instance;
              if (getKClass(ApiEarnedWageAccessUserData).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.k8z_1 = this.e8z_1;
                this.l8z_1 = this.k8z_1;
                this.n8_1 = 6;
                var tmp_22 = this.l8z_1.y4u();
                var tmp_23 = getKClass(ApiEarnedWageAccessUserData);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiEarnedWageAccessUserData), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.m8z_1 = this.e8z_1;
                this.n8z_1 = this.m8z_1;
                this.n8_1 = 5;
                var tmp_27 = this.n8z_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.o8z_1 = Companion_instance;
              this.n8_1 = 4;
              suspendResult = mapApiErrorResponse(this.e8z_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.z8y_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.a8z_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 11;
            continue $sm;
          }

        case 4:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.o8z_1;
          tmp_33.g8z_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 10;
          continue $sm;
        case 5:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiEarnedWageAccessUserData), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.j8z_1 = tmp$ret$0;
          this.n8_1 = 7;
          continue $sm;
        case 6:
          var tmp_37 = this;
          tmp_37.j8z_1 = suspendResult instanceof ApiEarnedWageAccessUserData ? suspendResult : THROW_CCE();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          var tmp1 = this.j8z_1;
          var tmp_38 = this;
          this.i8z_1;
          tmp_38.h8z_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 12;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          this.o8_1 = 12;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.h8z_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 9;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.o8_1 = 12;
          var tmp_43 = this;
          var this_2 = this.h8z_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.g8z_1 = tmp_44.ul_1;
          this.n8_1 = 10;
          continue $sm;
        case 10:
          this.a8z_1 = new Result(this.g8z_1);
          this.n8_1 = 11;
          continue $sm;
        case 11:
          return this.a8z_1;
        case 12:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 12) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function PayRemoteSource(apiClient) {
  this.l8x_1 = apiClient;
}
protoOf(PayRemoteSource).s8u = function (companyId, $completion) {
  var tmp = new $fetchEarnedWageAccessSettingsCOROUTINE$5(this, companyId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(PayRemoteSource).i8v = function (companyId, userId, $completion) {
  var tmp = new $fetchEarnedWageAccessUserCOROUTINE$7(this, companyId, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_payModule() {
  _init_properties_PayModule_kt__rhj3nm();
  return payModule;
}
var payModule;
function payModule$lambda($this$module) {
  _init_properties_PayModule_kt__rhj3nm();
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp1 = new TypeQualifier(getKClass(EarnedWageAccessSettings));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = payModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance_2().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ILocalSource), tmp1, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp5 = new TypeQualifier(getKClass(EarnedWageAccessUserEntity));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = payModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_2().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ILocalSource), tmp5, definition_0, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = payModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance_2().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IPayRemoteSource), null, tmp2, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = payModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance_2().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(PayAccessor), null, definition_1, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = payModule$lambda$lambda_3;
  var scopeQualifier_3 = Companion_getInstance_2().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Singleton_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(IClairSdkAppKeyProvider), null, definition_2, kind_3, secondaryTypes_3);
  var factory_3 = new SingleInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_3);
  }
  new KoinDefinition($this$module, factory_3);
  return Unit_instance;
}
function payModule$lambda$lambda($this$single, it) {
  _init_properties_PayModule_kt__rhj3nm();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('earned_wage_access_settings', tmp$ret$0);
}
function payModule$lambda$lambda_0($this$single, it) {
  _init_properties_PayModule_kt__rhj3nm();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('earned_wage_access_user', tmp$ret$0);
}
function payModule$lambda$lambda_1($this$factory, it) {
  _init_properties_PayModule_kt__rhj3nm();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new PayRemoteSource(tmp$ret$0);
}
function payModule$lambda$lambda_2($this$single, it) {
  _init_properties_PayModule_kt__rhj3nm();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(EarnedWageAccessSettings));
  var tmp = $this$single.q1d(getKClass(ILocalSource), qualifier, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier_0 = new TypeQualifier(getKClass(EarnedWageAccessUserEntity));
  var tmp_0 = $this$single.q1d(getKClass(ILocalSource), qualifier_0, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(IPayRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$5 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  return new PayRepository(tmp, tmp_0, tmp_1, tmp$ret$5);
}
function payModule$lambda$lambda_3($this$single, it) {
  _init_properties_PayModule_kt__rhj3nm();
  return new ClairSdkAppKeyProvider();
}
var properties_initialized_PayModule_kt_cgdlr8;
function _init_properties_PayModule_kt__rhj3nm() {
  if (!properties_initialized_PayModule_kt_cgdlr8) {
    properties_initialized_PayModule_kt_cgdlr8 = true;
    payModule = module_0(VOID, payModule$lambda);
  }
}
function EarnedWageAccessSettings(isEarnedWageAccessEnabled) {
  this.p8z_1 = isEarnedWageAccessEnabled;
}
protoOf(EarnedWageAccessSettings).toString = function () {
  return 'EarnedWageAccessSettings(isEarnedWageAccessEnabled=' + this.p8z_1 + ')';
};
protoOf(EarnedWageAccessSettings).hashCode = function () {
  return getBooleanHashCode(this.p8z_1);
};
protoOf(EarnedWageAccessSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EarnedWageAccessSettings))
    return false;
  var tmp0_other_with_cast = other instanceof EarnedWageAccessSettings ? other : THROW_CCE();
  if (!(this.p8z_1 === tmp0_other_with_cast.p8z_1))
    return false;
  return true;
};
function IClairSdkAppKeyProvider() {
}
function PayAccessor() {
}
function ClairSdkAppKeyProvider() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
Companion_instance_2 = new Companion_0();
//endregion
//region block: exports
export {
  get_payModule as get_payModule2wd4vuq8zftko,
  IClairSdkAppKeyProvider as IClairSdkAppKeyProvider1y5oia2cqp2x4,
  PayAccessor as PayAccessorv7chehvo6140,
};
//endregion

